import { wrapCall, callGet, callPut, callPost, callDelete } from './helpers'

//* ~~~~~~ CUSTOM FIELD ROUTES ~~~~~~

// Gets custom fields
export const getCustomFields = async () => {
  return (await wrapCall({
    method: callGet,
    uri: `/customfields`
  })) as APICustomField[]
}

// Creates custom fields
export const postCustomFields = async (data: CustomFieldUpdate[]) => {
  return (await wrapCall({
    method: callPost,
    uri: `/customfields`,
    data: { data }
  })) as APICustomField[]
}

// Updates custom fields
export const putCustomFields = async (data: CustomFieldUpdate[]) => {
  return (await wrapCall({
    method: callPut,
    uri: `/customfields`,
    data: { data }
  })) as APICustomField[]
}

//* ~~~~~~ GROUPS ROUTES ~~~~~~

// Gets custom field groups
export const getCustomFieldGroups = async (
  type: APICustomFieldGroup['object_type']
) => {
  return (await wrapCall({
    method: callGet,
    uri: `/customfields/groups?object_type=${type}`
  })) as APICustomFieldGroup[]
}

// Create custom field group
export const postCustomFieldGroup = async (
  data: CustomFieldGroupPOSTUpdate
) => {
  return (await wrapCall({
    method: callPost,
    uri: '/customfields/groups',
    data
  })) as APICustomFieldGroup
}

// Update a custom field group
export const putCustomFieldGroup = async (
  id: string,
  data: Omit<CustomFieldGroupPUTUpdate, 'id'>
) => {
  return (await wrapCall({
    method: callPut,
    uri: `/customfields/groups/${id}`,
    data
  })) as APICustomFieldGroup
}

// Remove a custom field group
export const deleteCustomFieldGroup = async (id: string) => {
  return await wrapCall({
    method: callDelete,
    uri: `/customfields/groups/${id}`
  })
}

//* ~~~~~~ FLOWS ROUTES ~~~~~~

export const getFlows = async (type: APICustomFieldGroup['object_type']) => {
  const allFlows = (await wrapCall({
    method: callGet,
    uri: `/customfields/~/flows?object_type=${type}`
  })) as APIFlow[]
  return allFlows.filter(flow => flow.object_type === type)
}

export const postFlow = async (data: FlowUpdate) => {
  return (await wrapCall({
    method: callPost,
    uri: '/customfields/~/flows',
    data
  })) as APIFlow
}

export const putFlow = async (id: string, data: FlowUpdate) => {
  return (await wrapCall({
    method: callPut,
    uri: `/customfields/~/flows/${id}`,
    data
  })) as APIFlow
}

export const deleteFlow = async (id: string) => {
  return await wrapCall({
    method: callDelete,
    uri: `/customfields/~/flows/${id}`
  })
}
